/* eslint-disable import/prefer-default-export */
export const UPDATE_ALL_ADMINS = 'UPDATE_ALL_ADMINS';
export const UPDATE_ALL_ROLES = 'UPDATE_ALL_ROLES';
export const UPDATE_ALL_PERMISSIONS = 'UPDATE_ALL_PERMISSIONS';
export const UPDATE_ALL_EXISTING_ROLE_PERMISSIONS = 'UPDATE_ALL_EXISTING_ROLE_PERMISSIONS';
export const UPDATE_ALL_NONEXISTING_ROLE_PERMISSIONS = 'UPDATE_ALL_NONEXISTING_ROLE_PERMISSIONS';
export const UPDATE_ALL_PRODUCT_BALANCES = 'UPDATE_ALL_PRODUCT_BALANCES';
export const UPDATE_USERS_ACTIVE_PRODUCTS = 'UPDATE_USERS_ACTIVE_PRODUCTS';
